import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

/**
 * Respuesta dummy de `user-context` mientras el BFF de autorización definitivo
 * no está disponible. Estructura alineada con {@link UserContext}, con datos
 * de ejemplo de un cliente del Portal de Clientes FID Seguros.
 */
const MOCK_USER_CONTEXT_RESPONSE = {
  data: {
    userContext: {
      userAccount: {
        id: '1',
        externalId: 'MOCK-EXTERNAL-ID',
        externalIdentifier: 'maria.contreras@gmail.com',
        enabled: true,
        person: {
          personalId: '15.234.876-K',
          name: 'María José Contreras Soto'
        }
      },
      groups: [
        {
          id: 'g-1',
          name: 'Portafolio de Seguros',
          roles: [
            {
              id: 'r-1',
              name: 'Seguro Automotriz — Vigente',
              permits: ['policy.view_detail', 'policy.download_certificate', 'claims.create']
            },
            {
              id: 'r-2',
              name: 'Seguro de Vida — Vigente',
              permits: ['policy.view_detail', 'policy.download_certificate']
            }
          ]
        }
      ]
    }
  }
};

/**
 * Interceptor funcional que sustituye la respuesta del servicio `user-context`
 * del BFF de autorización por un dummy, controlado por `USE_MOCK_BFF` en el
 * environment activo. Se retira automáticamente poniendo ese flag en `false`
 * una vez que el BFF definitivo esté disponible.
 */
export const mockBffInterceptor: HttpInterceptorFn = (req, next) => {
  const targetServiceUrl = environment.auth_environment.BFF_BACKEND_SERVICE_USER_CONTEXT;

  if (environment.auth_environment.USE_MOCK_BFF && req.url.includes(targetServiceUrl)) {
    console.warn('[Mock BFF] USE_MOCK_BFF=true: respondiendo user-context con datos dummy.');
    return of(new HttpResponse({ status: 200, body: MOCK_USER_CONTEXT_RESPONSE })).pipe(delay(300));
  }

  return next(req);
};
